﻿import { routingFlags, RoutingFlagsT } from '@constants/routingFlags';
import { fetchRoutingFlags } from '@store/routingFlag/services';
import { setRoutingFlagStore } from '@store/routingFlag/store';
import { RoutingFlagDto, RoutingFlagModel } from '@store/routingFlag/types';

export const getRoutingFlags = async (): Promise<void> => {
  setRoutingFlagStore({ isLoading: true, isError: false });
  try {
    const flags = await fetchRoutingFlags();
    if (flags !== undefined) {
      const mergedFlags = mergeRoutingFlags(routingFlags, flags);
      setRoutingFlagStore({
        isLoading: false,
        loaded: true,
        flags: mergedFlags,
      });
    } else {
      setRoutingFlagStore({ isLoading: false, loaded: true, flags: [] });
    }
  } catch (error) {
    setRoutingFlagStore({
      isLoading: false,
      isError: true,
      loaded: true,
      flags: [],
    });
  }
};

/**
 * Merges routing flags with their values from the backend.
 * Matches by id, takes name from RoutingFlagsT and value from routingFlagDto.
 */
export const mergeRoutingFlags = (
  flags: RoutingFlagsT[],
  dtos: RoutingFlagDto[],
): RoutingFlagModel[] => {
  const dtoMap = new Map(dtos.map((dto) => [dto.id.toUpperCase(), dto.value]));

  return flags
    .filter((flag) => dtoMap.has(flag.id.toUpperCase()))
    .map((flag) => ({
      id: flag.id,
      name: flag.name,
      value: dtoMap.get(flag.id.toUpperCase()) ?? '',
    }));
};
